<script>
    import { onMount } from 'svelte';

    export let SERVER;

    let vid = null;

    onMount(async () => {
		const res = await fetch(SERVER + '/api/video/top');
		let data = await res.json();
        vid = data.data.vid;
	});

    const fetchVideos = async () => {
		const response = await fetch(SERVER + '/api/videos');
        return await response.json();
	};

</script>

<section id="learn" class="container-fluid px-0">
    <div id="learn-header" class="d-flex align-items-center justify-content-center mt-5 mb-5 p-4">
        <div class="text-light">
            <h2 class="text-center">LEARN MANDARIN</h2>
            <p>Enjoy and sing along to trendy mandarin songs with english translation</p>
        </div>
    </div>

    <div id="learn-body">
        <div class="d-flex align-items-center justify-content-center">
            <div class="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/{vid}" title="" allowfullscreen></iframe>
            </div>
        </div>

        <div class="videos row mt-2 gy-3">
            {#await fetchVideos()}
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            {:then responseJson}
                {#each responseJson.data as video, index}
                <div class="col-6 col-sm-4 col-md-3 col-lg-2">
                    <img src="{video.thumbnail}" class="btn" alt="..." title={video.title} on:click={()=> {vid=video.vid}}>
                </div>
                {/each}
            {:catch error}
            <p>An error occurred!</p>
            {/await}
        </div>
    </div>

</section>

<style>
    #learn {
        margin-bottom: 4rem;
    }

    #learn-header {
        background-color: #f13c1f;
    }

    #learn-body {
        padding-left: 10vw;
        padding-right: 10vw;
    }

</style>
